export const imagesMediaFilesType = ["png", "jpg", "jpeg", "gif"];
